import { render, staticRenderFns } from "./SubQuestionWrapper.vue?vue&type=template&id=7163b9f1&"
import script from "./SubQuestionWrapper.vue?vue&type=script&lang=js&"
export * from "./SubQuestionWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports